module.exports = __webpack_public_path__ + "static/media/tournament-thumb-10ball.dbec37bf.png";